export default "__VITE_PUBLIC_ASSET__035dd9ff__"